import { useState } from 'react';

interface Props {
  onDecline: (reason: string) => void;
  onCancel: () => void;
}

export default function DeclineModal({ onDecline, onCancel }: Props) {
  const [reason, setReason] = useState('');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-5 border-b">
          <h3 className="text-lg font-semibold text-gray-900">Decline to Sign</h3>
          <p className="text-sm text-gray-500 mt-1">
            Are you sure you want to decline? The sender will be notified.
          </p>
        </div>

        <div className="p-5">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Reason for declining <span className="text-red-500">*</span>
          </label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Please provide a reason..."
            rows={3}
            className="w-full px-4 py-3 border border-gray-200 rounded text-gray-900 focus:outline-none focus:border-gray-400 resize-none"
          />
        </div>

        <div className="p-5 border-t bg-gray-50 flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border rounded hover:bg-gray-50"
          >
            Go Back
          </button>
          <button
            onClick={() => onDecline(reason)}
            disabled={!reason.trim()}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-red-600 rounded hover:bg-red-700 disabled:opacity-50"
          >
            Decline to Sign
          </button>
        </div>
      </div>
    </div>
  );
}
